var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "club-info-banner",
      class: {
        "club-info-banner_fixed-bottom": _vm.fixedBottomValue,
      },
      style: {
        bottom: _vm.fixedBottomValue ? _vm.fixedBottomValue : "initial",
      },
      attrs: { "data-qa": "club_info_banner" },
      on: { click: _vm.handleClubInfoBannerClick },
    },
    [
      _vm.discountOnServices
        ? _c(
            "div",
            {
              staticClass: "club-info-banner__price-discount",
              attrs: { "data-qa": "club_info_banner_percent" },
            },
            [_vm._v("\n    -" + _vm._s(_vm.discountOnServices) + "%\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "pr-10" }, [
        _c(
          "div",
          {
            staticClass: "text-subtitle-1 error--text",
            attrs: { "data-qa": "club_info_banner_title" },
          },
          [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]
        ),
        _vm._v(" "),
        _vm.subtitle
          ? _c(
              "div",
              {
                staticClass: "text-body-2 text-secondary--text",
                attrs: { "data-qa": "club_info_banner_subtitle" },
              },
              [_vm._v("\n      " + _vm._s(_vm.subtitle) + "\n    ")]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("span", {
        staticClass: "club-info-banner__icon error--text",
        class: _vm.showInfoIcon
          ? "ui-icon-circle-info"
          : "ui-icon-arrow-right ui-icon-fz-medium",
        attrs: {
          "data-qa": `${
            _vm.showInfoIcon
              ? "club_info_banner_icon_info"
              : "club_info_banner_icon_arrow"
          }`,
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }